export default __webpack_public_path__ + "de4ab09fdc786ecce620f135dec89317.png";